import gettingStarted from './getting-started.json'
import buildingsAccess from './buildings-access.json'
import documents from './documents.json'
import integrations from './integrations.json'
import tasks from './tasks.json'
import remedials from './remedials.json'
import compliance from './compliance.json'
import reports from './reports.json'
import organisation from './organisation.json'

export const WORKFLOWS = [
  ...gettingStarted,
  ...buildingsAccess,
  ...documents,
  ...integrations,
  ...tasks,
  ...remedials,
  ...compliance,
  ...reports,
  ...organisation,
].map(workflow => ({ ...workflow, kind: 'workflow', version: workflow.version || 1 }))
